import { Icon } from '../../icons';
import {
  CheckboxIndicator,
  Checkbox as CheckboxPrimitive,
  type CheckboxProps as CheckboxPrimitiveProps,
} from '../../primitives';
import { cn, cva } from '../../shared';

export const checkboxVariants = cva([
  'size-checkbox border-input bg-field-bg shrink-0 rounded-sm border',
  'focus-ring grid place-items-center transition-colors duration-fast',
  'disabled:opacity-50',
  'data-[state=checked]:bg-primary data-[state=checked]:border-primary',
  'data-[state=indeterminate]:bg-primary data-[state=indeterminate]:border-primary',
  'text-primary-foreground',
  // Same source of truth as Input: the attribute assistive technology reads is
  // the one the styling keys off.
  'aria-invalid:border-destructive aria-invalid:[--ring:var(--destructive)]',
]);

export type CheckboxProps = CheckboxPrimitiveProps;

/**
 * The box only. Its label is a sibling `<label htmlFor>` rather than children,
 * because a checkbox whose label is inside it cannot be placed to its left, and
 * every layout that needs that ends up rebuilding the component.
 *
 * `indeterminate` is a third value of `checked`, not a separate prop — a parent
 * row that is partly selected is neither on nor off.
 */
export function Checkbox({ className, ...props }: CheckboxProps) {
  return (
    <CheckboxPrimitive className={cn(checkboxVariants(), className)} {...props}>
      <CheckboxIndicator className="grid place-items-center">
        {props.checked === 'indeterminate' ? (
          <Icon name="minus" size="xs" aria-hidden="true" />
        ) : (
          <Icon name="check" size="xs" aria-hidden="true" />
        )}
      </CheckboxIndicator>
    </CheckboxPrimitive>
  );
}
